
export default function Products() {
  const products = [
    {
      title: 'VPN Protection',
      description: 'Secure your online presence with military-grade encryption. Browse privately, access content globally, and protect your data from prying eyes with our advanced VPN technology.',
      icon: 'ri-shield-check-line',
      color: 'from-emerald-50 to-teal-50',
      iconColor: 'text-emerald-600',
      image: 'https://public.readdy.ai/ai/img_res/b06619991de099592a2abc9929f6dd7c.jpg'
    },
    {
      title: 'Device Cleaner',
      description: 'Optimize your device performance by removing junk files, clearing cache, and managing storage efficiently. Keep your iOS device running smoothly with intelligent cleaning algorithms.',
      icon: 'ri-brush-line',
      color: 'from-violet-50 to-purple-50',
      iconColor: 'text-violet-600',
      image: 'https://readdy.ai/api/search-image?query=Modern%20iPhone%20mockup%20showing%20cleaner%20application%20interface%20with%20storage%20optimization%20graphs%20and%20file%20management%20tools%20on%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20lighting%2C%20minimalist%20design%20displaying%20storage%20analysis%20and%20cleaning%20progress%20indicators&width=600&height=800&seq=cleaner-product-002&orientation=portrait'
    },
    {
      title: 'Performance Boost',
      description: 'Experience lightning-fast performance with our optimization tools. Our applications are engineered to maximize efficiency while minimizing battery consumption and resource usage.',
      icon: 'ri-speed-line',
      color: 'from-sky-50 to-blue-50',
      iconColor: 'text-sky-600',
      image: 'https://readdy.ai/api/search-image?query=Modern%20iPhone%20mockup%20displaying%20performance%20optimization%20app%20interface%20with%20speed%20metrics%20and%20battery%20efficiency%20indicators%20on%20clean%20white%20background%2C%20professional%20product%20photography%20style%20with%20elegant%20lighting%2C%20minimalist%20design%20showing%20system%20performance%20graphs%20and%20optimization%20tools&width=600&height=800&seq=performance-product-003&orientation=portrait'
    }
  ];

  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-xs uppercase tracking-wider text-gray-500 mb-4 font-semibold">
            Our Solutions
          </div>
          <h2 className="text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
            VPN &amp; Cleaner
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {products.map((product, index) => (
            <div 
              key={index}
              className={`rounded-3xl p-10 bg-gradient-to-br ${product.color} hover:shadow-xl transition-shadow duration-300`}
            >
              <div className={`w-14 h-14 flex items-center justify-center mb-8 ${product.iconColor}`}>
                <i className={`${product.icon} text-4xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {product.title}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed">
                {product.description}
              </p>
            </div>
          ))}
        </div>

        {/* Product Showcase */}
        <div className="bg-gray-50 rounded-3xl p-12">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-2 mb-4">
              <i className="ri-apps-line text-teal-600 text-xl"></i>
              <span className="text-sm uppercase tracking-wider text-gray-600 font-semibold">
                Featured Products
              </span>
            </div>
            <h3 className="text-5xl font-bold text-gray-900">
              Our Applications
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-product-shop>
            {products.map((product, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="relative w-full h-80">
                  <img 
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className={`w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br ${product.color}`}>
                      <i className={`${product.icon} text-xl ${product.iconColor}`}></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-gray-900">{product.title}</h4>
                      <p className="text-xs text-gray-500">iOS Application</p>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {product.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Technology Stack */}
        <div className="mt-20 bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-12">
          <div className="mb-12">
            <div className="text-xs uppercase tracking-wider text-gray-500 mb-4 font-semibold">
              Technology
            </div>
            <h3 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              <span className="text-gray-400 italic font-light">Built with</span><br />
              Modern Standards
            </h3>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-7xl font-black text-teal-600 mb-2">iOS 17</div>
              <p className="text-sm text-gray-600">Latest Platform</p>
            </div>
            <div className="text-center">
              <div className="text-7xl font-black text-gray-800 mb-2">Swift 5</div>
              <p className="text-sm text-gray-600">Modern Language</p>
            </div>
            <div className="text-center">
              <div className="text-7xl font-black text-teal-600 mb-2">100%</div>
              <p className="text-sm text-gray-600">Native Code</p>
            </div>
            <div className="text-center">
              <div className="text-7xl font-black text-gray-800 mb-2">24/7</div>
              <p className="text-sm text-gray-600">Support</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}